import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientsDropdownTemplate from "@Shared/@HandlebarsTemplates/general/_clients-dropdown.hbs";
import { GenericModal } from "@Shared/components/modals";
import Select2 from "@Shared/components/inputs/select2";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { MAIN_API } from "@Shared/utils/constants";
import { mapState } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LinkApplicationsModal",
  components: {
    GenericModal,
    Select2,
    ProfileAvatar
  },
  props: {
    owner: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      clientSelected: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["apiBasePath", "userDetails", "token"])), {}, {
    options() {
      return {
        ajax: {
          url: `${MAIN_API}${this.apiBasePath}/${this.userDetails.username}/client`,
          type: "GET",
          data: params => ({
            agentUsername: this.owner.username,
            searchString: params.term,
            limit: 10,
            offset: 0
          }),
          headers: {
            "content-type": "application/json",
            "x-auth-token": this.token
          },
          processResults: (data, params) => {
            var _context;
            const mapped = _mapInstanceProperty(_context = data.clients).call(_context, client => {
              client.id = client.username;
              return client;
            });
            const page = params.page ? params.page : 1;
            return {
              results: mapped,
              pagination: {
                more: page * 10 < data.total
              }
            };
          },
          dataType: "json",
          delay: 250
        },
        dropdownCssClass: "link-app-select",
        placeholder: this.$t("client-profile.messages.searchAClient"),
        minimumInputLength: 3,
        dropdownParent: "#link-app-select-container",
        escapeMarkup: markup => markup,
        templateResult: this.formatRepoClient,
        templateSelection: this.formatClientSelection
      };
    }
  }),
  methods: {
    handleSelect({
      id
    }) {
      this.clientSelected = id;
    },
    linkApplication() {
      this.$emit("link-application", this.clientSelected);
      this.hide();
    },
    formatRepoClient(client) {
      if (client.loading) return `${this.$t("client-profile.messages.searchAClient")}...`;
      return ClientsDropdownTemplate(client);
    },
    formatClientSelection({
      givenName,
      familyName,
      text
    }) {
      return givenName && familyName ? `${givenName} ${familyName}` : text;
    },
    show() {
      this.$refs.linkAppModal.show();
    },
    hide() {
      this.$refs.linkAppModal.hide();
    }
  }
});